import { render, staticRenderFns } from "./ReplacementsPage.vue?vue&type=template&id=103b52d8&"
import script from "./ReplacementsPage.vue?vue&type=script&lang=ts&"
export * from "./ReplacementsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports